export class EnvelopeViewOutDTO {
  url!: string;
}
